import React from "react";
import { useState, useEffect } from "react";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import DoctorReview from "../Components/DoctorReview";

function DoctorDetail() {
  const [users, setUsers] = useState();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const getUsers = async () => {
      try {
        const response = await axiosPrivate.get(`user/doctor/${id}/`, {});
        const count = await axiosPrivate.get(`appointment/count/${id}/`);
        setCount(count.data);
        setUsers(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getUsers();
  }, []);

  return (
    <div>
      <div className="mx-3 px-3 mx-md-5 px-md-5 py-3 mt-5 bg-light">
        <div className="row row-cols-md-2">
          <div className="mt-2">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-evenly">
              <div>
                <img
                  src={users?.user_detail["user_image"]}
                  className="border border-5 border-dark rounded-circle"
                  width={200}
                  height={200}
                  alt="doctor"
                />
              </div>
              <div className="mt-3 mt-md-0">
                <h4 className="">Dr. {users?.user_detail["name"]}</h4>
                <p className="mb-1">
                  <strong>{users?.specialization}</strong>
                </p>
                <p className="mb-1">
                  <strong>No. of Patients: {count}</strong>
                </p>
              </div>
            </div>
          </div>
          <div className="mt-md-4">
            <h4 className="text-center mt-4">About</h4>
            <p className="text-center">{users?.description}</p>
          </div>
        </div>
        <div className="row row-cols-md-2 mt-5 mx-2 justify-content-evenly">
          <div className="card col-md-5 pb-3 px-3 px-md-5 mb-3 mb-md-4">
            <h4 className="text-center pt-2 pt-md-4">Education</h4>
            {users?.education.length ? (
              users?.education.map((education, j) => (
                <div key={j} className="mb-3">
                  <hr className="m-0" />
                  <h5>
                    {j + 1}. {education.degree}
                  </h5>
                  <h6 className="ms-5">
                    {education.university}, {education.year}
                  </h6>
                </div>
              ))
            ) : (
              <label>N/A</label>
            )}
          </div>
          <div className="card col-md-5 px-3 px-md-5 mb-3 mb-md-4 pb-3">
            <h4 className="text-center pt-2 pt-md-4">Experience</h4>
            {users?.experience.length ? (
              users?.experience.map((experience, j) => (
                <div key={j} className="mb-3">
                  <hr className="m-0" />
                  <h5>
                    {j + 1}. {experience.position}
                  </h5>
                  <h6 className="ms-5">
                    {experience.company}, {experience.year}
                  </h6>
                </div>
              ))
            ) : (
              <label>N/A</label>
            )}
          </div>
        </div>
      </div>
      <div className="text-center py-4 m-auto">
        <h5 className="d-inline mx-4">Fee: Rs. {users?.fees}</h5>
        <a className="btn btn-primary" href={`/book/doctor/${id}`}>
          Book Appointment
        </a>
      </div>
      <DoctorReview />
    </div>
  );
}

export default DoctorDetail;
